import React from 'react';
import PropTypes from 'prop-types';
import style from './QQLegend.module.css';

const QQLegend = ({ isDetailView }) => {
  const detailClass = isDetailView ? style.detailView : '';

  const col = (color, title) => (
    <div className={style.col}>
      <div className={`${style.colorBox} ${style[color]}`} />
      <div className={style.title}>{title}</div>
    </div>
  );

  const updatedWrapperClass = 'v2';

  return (
    <div className={`${style.legendWrapper} ${detailClass} ${updatedWrapperClass}`}>
      {col('blue', 'Correct first try')}
      {col('lightBlue', 'Eventually correct')}
      {col('red', 'Incorrect')}
      {col('gray', 'Unanswered')}
    </div>
  );
};

QQLegend.propTypes = {
  isDetailView: PropTypes.bool,
};

export default QQLegend;
